.wrapper {
  color: #231e19;
  padding-top: 32px;
}

.title {
  text-align: center;
  font-family: var(--ed-font-rounded, 'SF Pro Rounded', Nunito, 'Roboto', sans-serif);
  font-size: 22px;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: 0.088px;
  margin-bottom: 20px;
}

// Dark mode
:global body.dark {
  :local {
    .title {
      color: #fffbf2;
    }
  }
}
